import React, { useContext, useState } from 'react';
import { KatBox } from '@amzn/katal-react';
import { IDownload } from 'src/state/slice/models/CommonTypes';
import { KatIcon, KatSpinner, KatAlert } from '@amzn/katal-react';
import { downloadFile } from 'src/integration/dms/DmsFileDownloadClient';
import { FileAttachmentsConstants } from 'src/constants/ProjectConstants';
import styled from 'styled-components';
import { TranslationContext } from 'src/state/providers/TranslationProvider';

export const FileDownload = ({ documentName, documentId }: IDownload) => {
  const [spinner, setSpinner] = useState(false);
  const [error, setError] = useState(false);

  const showSpinner = (status: boolean) => setSpinner(status);
  const showError = (status: boolean) => setError(status);

  const FileDownloadItem = styled.div`
    .file {
      display: flex;
      justify-content: space-between;
      gap: 0.3rem;
      padding: 0.5rem;
      align-items: center;
      cursor: pointer;
    }
    .file:hover,
    .file:focus {
      color: ${({ theme }) => theme.colors.Eastern};
    }
    .boxItem {
      flex: 1;
    }
  `;

  const { fileUploaderBundle } = useContext(TranslationContext);
  return (
    <>
      {error && (
        <KatAlert
          variant="danger"
          description={fileUploaderBundle.getMessage(
            FileAttachmentsConstants.DOWNLOAD_ERROR_DESCRIPTION,
          )}
        />
      )}
      <FileDownloadItem>
        <KatBox
          variant="white"
          className="file"
          onClick={() => {
            downloadFile({ documentName, documentId, showSpinner, showError });
          }}
          id={`file-${documentId}`}
        >
          <KatIcon name="insert_drive_file" size="small" />
          <span className="boxItem" data-testid={documentId}>
            {documentName}
          </span>
          {spinner ? (
            <KatSpinner size="small" />
          ) : (
            <KatIcon name="file_download" size="small" />
          )}
        </KatBox>
      </FileDownloadItem>
    </>
  );
};
